module.exports = __webpack_public_path__ + "img/code.a8077ed9.svg";